// extracted by mini-css-extract-plugin
export default {"banner":"styles_banner__GXXyH","banner-image":"styles_banner-image__2uOfM","banner-text":"styles_banner-text__uQvFK","banner-button":"styles_banner-button__CE5vQ"};